import { defineComponent as r, computed as o, openBlock as c, createElementBlock as s, createElementVNode as t, toDisplayString as d, createCommentVNode as n, normalizeStyle as p, createStaticVNode as f } from "vue";
const m = ["viewBox"], v = /* @__PURE__ */ t("mask", { id: "6682e626-cc51-4a09-b24e-3d4c472661fd" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), _ = { mask: "url(#6682e626-cc51-4a09-b24e-3d4c472661fd)" }, g = { key: 0 }, k = /* @__PURE__ */ f('<path fill="#eee" d="m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"></path><path fill="#496e2d" d="M0 0h512v167H0z"></path><path fill="#d80027" d="M0 345h512v167H0z"></path><path fill="#333" d="m256 200.3 13.8 42.6h44.7L278.4 269l13.8 42.6-36.2-26.3-36.2 26.3 13.8-42.6-36.1-26.2h44.7z"></path><g fill="#eee"><path d="M332 50v52c0 8.2-6.6 14.9-14.8 14.9V139a37.1 37.1 0 0 0 37.1-37V50h-22.2zm-159.5 52c0 8.2-6.6 14.9-14.8 14.9V139a37.1 37.1 0 0 0 37-37V50h-22.2z"></path><path d="M298.7 50h22.2v52h-22.2zm-33.4 29.8a3.7 3.7 0 0 1-3.7 3.7 3.7 3.7 0 0 1-3.7-3.7V50h-22.3v29.7a3.7 3.7 0 0 1-3.7 3.7 3.7 3.7 0 0 1-3.7-3.7V50h-22.3v29.7a26 26 0 0 0 26 26 25.8 25.8 0 0 0 14.8-4.7 25.8 25.8 0 0 0 14.9 4.6c1 0 2.2 0 3.2-.2a14.9 14.9 0 0 1-14.4 11.4V139a37.1 37.1 0 0 0 37.1-37V50h-22.2v29.7z"></path><path d="M206 116.9h33.3V139h-33.4z"></path></g>', 5), u = { fill: "none" }, V = ["r"], y = /* @__PURE__ */ r({
  __name: "somaliland",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(h) {
    const e = h, a = o(() => 512 + 2 * e.strokeWidth), l = o(() => -e.strokeWidth), i = o(() => 256 + e.strokeWidth / 2);
    return (z, x) => (c(), s("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${l.value} ${l.value} ${a.value} ${a.value}`
    }, [
      v,
      t("g", _, [
        e.flagName ? (c(), s("title", g, d(e.flagName), 1)) : n("", !0),
        k
      ]),
      t("g", u, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: i.value,
          fill: "none",
          style: p({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, V)
      ])
    ], 8, m));
  }
});
export {
  y as default
};
//# sourceMappingURL=somaliland-2bab35d1.js.map
